import React from 'react'
import { useTranslation } from 'react-i18next'
import './404.css'

type Props = {}

const P404: React.FC<Props> = () => {
    const { t } = useTranslation()

    return (
        <div id="unexpected-error" style={{ flexDirection: 'column' }}>
            <section className="unexpected-error-block">
                <div className="no-gutters align-items-center">
                    <div className="col-12 unexpected-error-content p-4">
                        <h1>404</h1>
                        <p>{t('messages.pageNotFoundMsg')}</p>
                    </div>
                </div>
            </section>
            <div aria-hidden="true" className="plaintext-button">
                <a aria-hidden="true" onClick={() => { window.history.back() }}>
                    {t('actions.goBack')}
                </a>
            </div>
        </div>
    )
}

export default P404
